import { Percentage, RGB } from "@siteimprove/alfa-css";
import { None, Option } from "@siteimprove/alfa-option";
/**
 * @public
 */
export var Color;
(function (Color) {
    function resolve(color, style) {
        switch (color.type) {
            case "keyword":
                if (color.value === "currentcolor") {
                    color = style.computed("color").value;
                    if (color.type === "color") {
                        return Option.of(RGB.of(color.red, color.green, color.blue, Percentage.of(color.alpha.value)));
                    }
                }
                if (color.value === "canvastext") {
                    return Option.of(RGB.of(Percentage.of(0), Percentage.of(0), Percentage.of(0), Percentage.of(1)));
                }
                return None;
            case "color":
                return Option.of(RGB.of(color.red, color.green, color.blue, Percentage.of(color.alpha.value)));
        }
    }
    Color.resolve = resolve;
    /**
     * {@link https://drafts.fxtf.org/compositing-1/#simplealphacompositing}
     */
    function composite(foreground, background, opacity) {
        const foregroundOpacity = foreground.alpha.value * opacity;
        if (foregroundOpacity === 1) {
            return foreground;
        }
        const alpha = background.alpha.value * (1 - foregroundOpacity);
        const [red, green, blue] = [
            [foreground.red, background.red],
            [foreground.green, background.green],
            [foreground.blue, background.blue],
        ].map(([a, b]) => a.value * foregroundOpacity + b.value * alpha);
        return RGB.of(Percentage.of(red), Percentage.of(green), Percentage.of(blue), Percentage.of(foregroundOpacity + alpha));
    }
    Color.composite = composite;
})(Color || (Color = {}));
//# sourceMappingURL=color.js.map